import { render, staticRenderFns } from "./TheUrgentUploadOverlay.vue?vue&type=template&id=51964e9e&scoped=true&lang=html"
import script from "./TheUrgentUploadOverlay.vue?vue&type=script&lang=ts"
export * from "./TheUrgentUploadOverlay.vue?vue&type=script&lang=ts"
import style0 from "./TheUrgentUploadOverlay.vue?vue&type=style&index=0&id=51964e9e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51964e9e",
  null
  
)

export default component.exports